import { Navigate, useParams } from 'react-router-dom';

import { eventHref } from './trigger-utils';

/** Legacy `/runs/:eventId` and `/triggers/events/:eventId` paths, redirected to the shared event slideout. */
export const TriggerRunDetailPage = () => {
  const { eventId } = useParams<{ eventId: string }>();
  return <Navigate to={eventHref(eventId ?? '')} replace />;
};
